'use client'

import { createContext, useContext } from 'react'

import { PlayfairFont } from '../../../../app/_components/fonts/PlayfairFont'

import type { CollectionLayoutFragmentFragment } from '../../../../__generated__/graphql/catalog/graphql'

export type CollectionViewThemeName = NonNullable<CollectionLayoutFragmentFragment['theme']>

const CollectionViewThemeContext = createContext<CollectionViewThemeName | null>(null)

export const CollectionViewThemeProvider = ({
  theme,
  children,
}: {
  theme: CollectionViewThemeName | null
  children: React.ReactNode
}) => {
  return (
    <CollectionViewThemeContext.Provider value={theme}>
      {theme === 'elegant' && <PlayfairFont />}
      {children}
    </CollectionViewThemeContext.Provider>
  )
}

export const useCollectionViewTheme = () => useContext(CollectionViewThemeContext)
